import React from "react";
import PropTypes from "prop-types";
import { HashLink as Link } from "react-router-hash-link";

// Components
import { withBuilder, withChildren } from "@builder.io/react";

const scrollWithOffset = (el, offset) => {
  const elementPosition = el.offsetTop - offset;
  window.scroll({
    top: elementPosition,
    left: 0,
    behavior: "instant",
  });
};

export const renderLinkImage = (image) => {
  if (image) {
    return <img src={image} alt="" data-testid="image" />;
  }

  return null;
};

export const HashLink = ({ to, children, image }) => (
  <Link to={to} scroll={(el) => scrollWithOffset(el, 40)}>
    {children}
    {renderLinkImage(image)}
  </Link>
);

HashLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.any,
  image: PropTypes.string,
};

HashLink.defaultProps = {
  children: null,
};

const HashLinkChildren = withChildren(HashLink);

export const HashLinkBlock = withBuilder(HashLinkChildren, {
  name: "Hash Link",
  image: "https://hatchbaby.imgix.net/webassets/hash-link-icon-builder.svg",
  inputs: [
    {
      name: "to",
      type: "string",
      defaultValue: "/rest#reviews",
    },
    {
      name: "children",
      type: "Object",
    },
    {
      name: "image",
      type: "file",
      allowedFileTypes: ["jpeg", "png"],
    },
  ],
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: { name: "Text", options: { text: "I am link text!" } },
    },
  ],
});

export default HashLink;
